module.exports = {"web":{"client_id":"469550835322-tcdos6afa80obe3k7g1uk30qfj65drsj.apps.googleusercontent.com","project_id":"oddmachine-mail","auth_uri":"https://accounts.google.com/o/oauth2/auth","token_uri":"https://accounts.google.com/o/oauth2/token","auth_provider_x509_cert_url":"https://www.googleapis.com/oauth2/v1/certs","client_secret":"7hf_CBrrJzpGRAnV-dnkzSjl"}}


//////////////////
// WEBPACK FOOTER
// ./src/data/client_id.json
// module id = 52
// module chunks = 0